<div class="label-list-wrapper">
  @for (
    tag of truncateLabels()
      ? (tags() | slice: 0 : amountBeforeTruncation())
      : tags();
    track tag
  ) {
    <app-wbs-tag
      class="labels-tag me-2 align-self-center"
      [tag]="tag"
      [enableUpperCase]="enableUpperCase()"
    >
    </app-wbs-tag>
  }
  @if (truncateLabels() && tags()?.length > amountBeforeTruncation()) {
    <div
      im-dropdown
      position="block-end"
      class="align-self-center me-2"
      (click)="$event.stopPropagation()"
    >
      <button imDropdownTrigger class="tag-list__overflow-trigger">
        <app-badge class="c-pointer">
          ... {{ tags()?.length - amountBeforeTruncation() }}
        </app-badge>
      </button>
      <div imDropdownMenu>
        <div class="tag-list__overflow">
          @for (
            tag of tags() | slice: amountBeforeTruncation() : tags()?.length;
            track tag
          ) {
            <div class="tag-list__overflow-entry">
              <app-wbs-tag
                class="labels-tag me-2 align-self-center"
                [tag]="tag"
                [enableUpperCase]="enableUpperCase()"
              >
              </app-wbs-tag>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
